import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "../Modal";
import RightSidebarStyle from "./style";
import { AddAnnouncement, EditAnnouncement, DeleteAnnouncement } from "../../Redux/Actions/AnnouncementAction";
import Close from "../../Assets/Close.svg";
import { connect } from "react-redux";
import moment from "moment/moment";

function RightSideBar(props) {
  const [response, setResponse] = useState(false);
  const [AnnouncementDescription, setAnnouncementDescription] = useState("");
  const [AnnouncementDescriptionError, setAnnouncementDescriptionError] = useState("");
  const [AnnouncementStartDate, setAnnouncementStartDate] = useState("");
  const [AnnouncementStartDateError, setAnnouncementStartDateError] = useState("");
  const [AnnouncementEndDate, setAnnouncementEndDate] = useState("");
  const [AnnouncementEndDateError, setAnnouncementEndDateError] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [deleteOptOut, setDeleteOptOut] = useState(false);

  useEffect(() => {
    if (props.data) {
      setAnnouncementDescription(props.data.name);
      setAnnouncementStartDate(props.data.start_date);
      setAnnouncementEndDate(props.data.end_date);
      setDeleteOptOut(false);
    }
  }, [props]);

  const CloseSidebar = (e) => {
    e.preventDefault();
    setAnnouncementDescription("");
    setAnnouncementStartDate("");
    setAnnouncementEndDate("");
    setDeleteOptOut(false);
    props.close();
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    if (type !== "delete") {
      const newStartDate = moment(AnnouncementStartDate).format("YYYY-MM-DD");
      const newEndDate = moment(AnnouncementEndDate).format("YYYY-MM-DD");
      if (newStartDate >= newEndDate) {
        alert("The start date must be prior to the end date.");
        return;
      }
      setModal(type);
    } else {
      setAnnouncementStartDateError("");
      setAnnouncementEndDateError("");
      setModal(type);
    }
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "delete_yes") {
      props.DeleteAnnouncement(props.data.id);
      props.close();
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    } else if (type === "update_yes") {
      const data = {
        description: AnnouncementDescription,
        start_date: moment(AnnouncementStartDate).format("YYYY-MM-DD"),
        end_date: moment(AnnouncementEndDate).format("YYYY-MM-DD"),
        id: props.data.id,
        remove_opt_outs: deleteOptOut,
      };
      props.EditAnnouncement(data);
      props.close();
      setModal(false);
    } else if (type === "add_yes") {
      const data = {
        description: AnnouncementDescription,
        start_date: moment(AnnouncementStartDate).format("YYYY-MM-DD"),
        end_date: moment(AnnouncementEndDate).format("YYYY-MM-DD"),
      };
      props.AddAnnouncement(data);
      setAnnouncementDescription("");
      setAnnouncementStartDate("");
      setAnnouncementEndDate("");
      props.close();
      setModal(false);
    } else if (type === "add_no") {
      setModal(false);
    } else {
      setModal(false);
    }
    if (type === "add_yes" || type === "update_yes" || type === "delete_yes") {
      setModal(false);
      setAnnouncementDescription("");
      setAnnouncementDescriptionError("");
      setAnnouncementStartDate("");
      setAnnouncementStartDateError("");
      setAnnouncementEndDate("");
      setAnnouncementEndDateError("");
      props.close();
    }
  };

  const handleAnnouncementDescription = (e) => {
    if (e.target.value.length < 256) {
      setAnnouncementDescription(e.target.value);
      setAnnouncementDescriptionError("");
    } else {
      setAnnouncementDescriptionError("Description must be less than 256 characters");
    }
  };

  const handleAnnouncementStartDate = (date) => {
    setAnnouncementStartDate(date ? date.toISOString() : "");
  };

  const handleAnnouncementEndDate = (date) => {
    setAnnouncementEndDate(date ? date.toISOString() : "");
  };

  const handleOptOut = (e, deleteOptOut) => {
    e.preventDefault();
    setDeleteOptOut(!deleteOptOut);
  };

  useEffect(() => {
    props.edit_data &&
      response &&
      props.response({
        type: props.edit_data.status,
        message: props.edit_data.message,
      });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data &&
      response &&
      props.response({
        type: props.delete_data.status,
        message: props.delete_data.message,
      });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data &&
      response &&
      props.response({
        type: props.add_data.status,
        message: props.add_data.message,
      });
  }, [props.add_data]);

  return (
    <>
      {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />}
      <div className={props && props.sidebar ? "dark-background right-sidebar-wrap" : "dark-background right-sidebar-wrap right-sidebar-wrap-close"}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} Announcement</h5>
          <img onClick={(e) => CloseSidebar(e)} src={Close} alt="Close" className="cursor-pointer" />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Announcement<span className="text-danger">*</span>
            </label>
            <input value={AnnouncementDescription} onChange={(e) => handleAnnouncementDescription(e)} type="text" id="Announcement" placeholder="Announcement text" className="w-100 input-style" autoComplete="off" />
            {AnnouncementDescriptionError && <p className="f-12 text-danger">{AnnouncementDescriptionError}</p>}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Start Date
              <span className="text-danger">*</span>
            </label>
            <ReactDatePicker onChange={(date) => handleAnnouncementStartDate(date)} id="AnnouncementStartDate" placeholderText="Select Date" className="w-100 text-input-style" selected={AnnouncementStartDate ? moment(AnnouncementStartDate).toDate() : null} minDate={new Date()} dateFormat="yyyy-MM-dd" />
            {AnnouncementStartDateError && <p className="f-12 text-danger">{AnnouncementStartDateError}</p>}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              End Date
              <span className="text-danger">*</span>
            </label>
            <ReactDatePicker onChange={(date) => handleAnnouncementEndDate(date)} id="AnnouncementEndDate" placeholderText="Select Date" className="w-100 text-input-style" selected={AnnouncementEndDate ? moment(AnnouncementEndDate).toDate() : null} minDate={new Date()} dateFormat="yyyy-MM-dd" />
            {AnnouncementStartDateError && <p className="f-12 text-danger">{AnnouncementEndDateError}</p>}
          </div>
          {props.Type !== "Add" && (
            <div className="mt-4">
              <label htmlFor="BA" className="text-grey-6 f-16 d-block mb-1">
                Remove Opt Outs
              </label>
              <p className={deleteOptOut ? "text-green label-para f-12" : "text-grey label-para f-12"}></p>
              <label className="switch mb-0">
                <input type="checkbox" checked={deleteOptOut} readOnly />
                <span className="slider round" onClick={(e) => handleOptOut(e, deleteOptOut)} />
              </label>
            </div>
          )}
          <div className="mt-5 mb-5 text-center">
            {props.Type === "Add" && (
              <button onClick={(e) => handleModal(e, "add")} className="form-button" disabled={!(AnnouncementDescription && AnnouncementStartDate && AnnouncementEndDate)}>
                Save
              </button>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button onClick={(e) => handleModal(e, "delete")} className="form-button form-button-ghost f-14 mr-2">
                  Delete
                </button>
                <button disabled={!(AnnouncementDescription && AnnouncementStartDate && AnnouncementEndDate)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                  Update
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && <Modal Name="this announcement" Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ GetAnnouncementReducer }) => {
  const { loading, delete_data, add_data, edit_data } = GetAnnouncementReducer;
  return { loading, delete_data, add_data, edit_data };
};

const mapDispatchToProps = {
  AddAnnouncement,
  EditAnnouncement,
  DeleteAnnouncement,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);
